module.exports = __webpack_public_path__ + "774aee7b702923ee7f0317526c5cfe0d.png";